import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'c-cierre-card',
    templateUrl: './cierre-card.component.html',
    styleUrl: './cierre-card.component.css',
    standalone: false
})
export class CierreCardComponent {
  @Input() titulo!: string;

  @ContentChild('contenidoHtml') contenidoHtml!: TemplateRef<any>;

  isCollapsed = true;
}
